import React from 'react';
import { Manager } from "socket.io-client";

let tenant_id = "";
const env = process.env.REACT_APP_ENV
    ? process.env.REACT_APP_ENV
    : "dev";
if (env === "local") {
    tenant_id = process.env.REACT_APP_tenant
        ? process.env.REACT_APP_tenant
        : "";
} else {
    const domain_url = process.env.REACT_APP_DOMAIN_URL
        ? process.env.REACT_APP_DOMAIN_URL
        : ".dev.rcmanagers.com";
    const host = window.location.host;
    const domain_prefix = host.replace(domain_url, "");
    tenant_id = process.env[`REACT_APP_${domain_prefix}`] ?? "";
}

export const socketManager = new Manager(`${process.env.REACT_APP_API_ENDPOINT}`, {
    reconnectionDelayMax: 10000,
    reconnection: true,
    transports: ["websocket"],
    query: {
        "tenant_id": tenant_id
    },
    closeOnBeforeunload: false
});

socketManager.open((err) => {
    if (err) {
        alert(`Error opening socket${err}`)
    } else {
        console.log(`socket connected`)
    }
});